import { render, staticRenderFns } from "./BizumPayment.vue?vue&type=template&id=8e88e740&scoped=true&"
import script from "./BizumPayment.vue?vue&type=script&lang=js&"
export * from "./BizumPayment.vue?vue&type=script&lang=js&"
import style0 from "./BizumPayment.vue?vue&type=style&index=0&id=8e88e740&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e88e740",
  null
  
)

export default component.exports